import { useAppContext } from "@ftdr/blueprint-components-react";
import { useCallback } from "react";
import { FailureTypeValue } from "../../../../types";
import { usePaymentsClientContext } from "../../../../../../contexts/payments-client-context";

export type UseHandleOnErrorType = {
  handleOnError: (err: Record<string, unknown>) => void;
};

export const useHandleOnError = (): UseHandleOnErrorType => {
  const {
    appSettings: { localizedText },
  } = useAppContext();
  const {
    applicationState: { onFailure },
  } = usePaymentsClientContext();

  const handleOnError = useCallback(
    (err) => {
      onFailure({
        type: FailureTypeValue.PAYPAL_FAILURE,
        paypalFailureResponse: {
          message: localizedText("BRAINTREE_LOGIN_ERROR"),
          rawError: err,
        },
      });
    },
    [localizedText, onFailure]
  );
  return { handleOnError };
};
